import { render, staticRenderFns } from "./OpcManage.vue?vue&type=template&id=04471791&scoped=true"
import script from "./OpcManage.vue?vue&type=script&lang=js"
export * from "./OpcManage.vue?vue&type=script&lang=js"
import style0 from "./OpcManage.vue?vue&type=style&index=0&id=04471791&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04471791",
  null
  
)

export default component.exports